/* eslint-disable tailwindcss/no-custom-classname */
import { Br } from "@/components/molecules/Br";
import { LogoMultiSec } from "@/components/molecules/logos/LogoMultiSec";
import Image from "next/image";
import careersMessage from "/public/careers-messageTani.webp";

const CareerMessage = () => {
  return (
    <div id="message" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl bg-bgc-dark px-8 py-10 font-bold text-pri md:p-20">
        <div className="relative z-10 flex flex-col gap-4 md:max-w-[576px] md:gap-8">
          <div className="space-y-2">
            <h4 className=" text-ter fluid-text-[11px,16px]">採用メッセージ</h4>
            <h3 className=" text-ter fluid-text-[16px,22px] ">Message</h3>
          </div>
          <h2 className=" fluid-text-[22px,45px] ">人との距離感が近い環境</h2>
          <div className="space-y-2 leading-comfort fluid-text-[14px,16px] md:space-y-4">
            <div>
              誠実なモノ作りをしたいと思っている人。
              <Br />
              新しいことに主体的に取り組める人。
              <Br />
              常に自分の技術を磨いていきたいと思っている人。
              <Br />
              そのような思いを持った人たちが活躍できる環境があります。
            </div>
            <div>
              ToccaSystemsは、人との距離感が近い環境です。
              <Br />
              一人ひとりが専門性を活かし、活躍できるチームづくりを
              <Br pc />
              大切にしています。
              <Br tb />
              自分の得意なことを伸ばしながら、
              <Br tbpc />
              様々なバックグラウンドを持つ仲間とともに成長していきましょう。
            </div>
          </div>
          <h4 className=" fluid-text-[18px,28px] ">
            人の成長が会社の成長に、
            <Br />
            会社の成長が人の成長に。
          </h4>
          <div className=" leading-comfort fluid-text-[14px,16px]">
            自分の家族や友人に「自分はこんな仕事をしたんだよ」と
            <Br tbpc />
            胸を張って言える、良い仕事ができるよう、
            <Br tbpc />
            1人ひとりの成長をサポートしていきます。
          </div>
        </div>
        <div className="absolute top-0 left-0 flex h-full w-full items-center justify-center">
          <LogoMultiSec className="h-[60%] w-auto fill-white md:h-[55%]" />
        </div>
        <figure className="absolute bottom-0 right-1/2 z-0 hidden aspect-[1/2.3351] h-auto w-[130px] flex-col items-start justify-end md:right-20 md:flex md:h-auto md:w-[220px] lg:h-auto lg:w-[320px]">
          <Image
            src={careersMessage}
            alt="代表取締役社長 谷 樹"
            quality={80}
            layout="fill"
            objectFit="cover"
            className="z-10"
          />
          <figcaption className="relative -left-28 z-20 mb-4 flex flex-col text-right text-txt-light md:-left-20">
            <span className="text-sm">代表取締役</span>谷 樹
          </figcaption>
        </figure>
      </div>
    </div>
  );
};

export default CareerMessage;
